import actionConstants from '../constants/';

const createCampaign = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const fetchCampaignDetail = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const configData = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const initialState = {
  createCampaign: { ...createCampaign },
  fetchCampaignDetail: { ...fetchCampaignDetail },
  configData: { ...configData },
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function createCampaignReducer(state = initialState, action) {
  switch (action.type) {
    case actionConstants.CREATE_CAMPAIGN_REQUEST:
      return {
        ...state,
        createCampaign: {
          ...state.createCampaign,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.CREATE_CAMPAIGN_SUCCESS:
      return {
        ...state,
        createCampaign: {
          ...state.createCampaign,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.CREATE_CAMPAIGN_FAILURE:
      return {
        ...state,
        createCampaign: {
          ...state.createCampaign,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.CREATE_CAMPAIGN_CLEAR:
      return {
        ...state,
        createCampaign: {
          ...createCampaign,
        },
      };

    case actionConstants.FETCH_CAMPAIGN_DETAIL_REQUEST:
      return {
        ...state,
        fetchCampaignDetail: {
          ...fetchCampaignDetail,
          isLoading: true,
        },
      };

    case actionConstants.FETCH_CAMPAIGN_DETAIL_SUCCESS:
      return {
        ...state,
        fetchCampaignDetail: {
          ...fetchCampaignDetail,
          isLoading: false,
          isSuccess: true,
          data: action.payload.body,
        },
      };

    case actionConstants.FETCH_CAMPAIGN_DETAIL_FAILURE:
      return {
        ...state,
        fetchCampaignDetail: {
          ...fetchCampaignDetail,
          isLoading: false,
          isFailure: true,
        },
      };

    case actionConstants.FETCH_CAMPAIGN_DETAIL_CLEAR:
      return {
        ...state,
        fetchCampaignDetail: {
          ...fetchCampaignDetail,
        },
      };

    case actionConstants.FETCH_CONFIG_DATA_FOR_CREATE_CAMPAIGN_REQUEST:
      return {
        ...state,
        configData: {
          ...state.configData,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.FETCH_CONFIG_DATA_FOR_CREATE_CAMPAIGN_SUCCESS:
      return {
        ...state,
        configData: {
          ...state.configData,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.FETCH_CONFIG_DATA_FOR_CREATE_CAMPAIGN_FAILURE:
      return {
        ...state,
        configData: {
          ...state.configData,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
          errorMessage: action.payload?.body?.error_message ?? '',
        },
      };

    case actionConstants.FETCH_CONFIG_DATA_FOR_CREATE_CAMPAIGN_CLEAR:
      return {
        ...state,
        configData: {
          ...initialState.configData,
          data: {},
          isLoading: false,
          isSuccess: false,
          isFailure: false,
        },
      };
    default:
      return state;
  }
}
